const tabButton = {
    height: "22px",
    alignItems: "center",
    color: "greyscale.700",
    backgroundColor: "greyscale.100",
    px: 1.75,
    borderColor: "greyscale.200",
    "& svg": {
        width: "16px",
        height: "18px",
        fill: "none"
    },
    "&:hover": {
        backgroundColor: "greyscale.200",
        borderColor: "greyscale.200"
    }
};

export const styles = {
    header: {
        border: "1px solid",
        borderColor: "greyscale.100"
    },
    heading: {
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "18px"
    },
    title: {
        margin: 2
    },
    sectionTitle: {
        color: "greyscale.800"
    },
    titleContent: {
        display: "flex",
        justifyContent: "flex-end"
    },
    container: {
        backgroundColor: "greyscale.50",
        padding: 0
    },
    buttonGroup: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "96px",
        height: "22px"
    },
    tabButton: {
        ...tabButton
    },
    activeButton: {
        ...tabButton,
        backgroundColor: "secondary.50",
        color: "primary.900",
        "&:hover": {
            backgroundColor: "secondary.100",
            borderColor: "greyscale.200"
        }
    },
    disabledButton: {
        ...tabButton,
        backgroundColor: "greyscale.100",
        color: "greyscale.400",
        "& > svg > g": {
            stroke: "#A7B7C7"
        }
    },
    footerButton: {
        mt: 1,
        mb: -0.5,
        ml: -1.75
    },
    cancelButton: {
        color: "greyscale.800"
    },
    revalidateButton: {
        mt: 1,
        mb: -0.5,
        ml: -2.5
    },
    content: {
        fontFamily: "Inter",
        color: "greyscale.900"
    },
    txtSqlDescription: {
        whiteSpace: "pre-wrap"
    },
    link: {
        height: "14px",
        paddingLeft: "4px",
        paddingTop: "7px",
        "& span": {
            color: "secondary.500"
        }
    },
    txtIncludeInput: {
        marginTop: 2,
        position: "relative",
        "& textarea": {
            minHeight: "96px"
        }
    },
    clearIconWrapper: {
        position: "absolute",
        top: 30,
        right: 10,
        cursor: "pointer",
        "& svg": {
            width: "16px",
            height: "16px"
        }
    },
    adornment: {
        alignSelf: "flex-end",
        alignItems: "center",
        gap: 0.5,
        mb: 0.5,
        height: "auto",
        maxHeight: "none"
    },
    inputClearIcon: {
        display: "inline-flex",
        cursor: "pointer",
        "& svg": {
            width: "16px",
            height: "16px"
        }
    },
    clearSvgIcon: {
        fill: "none"
    },
    fullScreenInput: {
        "& textarea": {
            minHeight: "300px",
            maxHeight: "600px",
            overflowY: "scroll !important"
        }
    },
    fullScreenQueryInput: {
        position: "relative",
        "& .CodeMirror": {
            border: "1px solid",
            borderColor: "greyscale.200",
            borderRadius: "8px",
            minHeight: "300px"
        },
        "& .CodeMirror:hover": {
            borderColor: "greyscale.300"
        },
        "& .CodeMirror:active": {
            borderColor: "secondary.300"
        },
        "& .CodeMirror:focus": {
            borderColor: "secondary.300"
        },
        "& .CodeMirror:focus-within": {
            borderColor: "secondary.300"
        }
    },
    queryInputExpandIcon: {
        display: "inline-flex",
        cursor: "pointer",
        "& svg": {
            width: "14px",
            height: "14px"
        }
    },
    queryInputDisabledIcon: {
        pointerEvents: "none",
        opacity: 0.5
    },
    sqlIncludeInput: {
        marginTop: 1,
        marginBottom: 1,
        position: "relative",
        "& .CodeMirror": {
            border: "1px solid",
            borderColor: "greyscale.200",
            borderRadius: "8px",
            height: "138px"
        },
        "& .CodeMirror:hover": {
            borderColor: "greyscale.300"
        },
        "& .CodeMirror:active": {
            borderColor: "secondary.300"
        },
        "& .CodeMirror:focus": {
            borderColor: "secondary.300"
        },
        "& .CodeMirror:focus-within": {
            borderColor: "secondary.300"
        }
    },
    txtExcludeInput: {
        marginTop: 2,
        marginBottom: 2,
        position: "relative",
        "& textarea": {
            minHeight: "66px",
            position: "relative"
        }
    },
    loading: {
        marginBottom: 2
    },
    editIcon: {
        fill: "none",
        "& > path": {
            stroke: ({ palette }) => palette.secondary[500]
        }
    },
    retryIcon: {
        fill: "none",
        "& > g > path": {
            stroke: ({ palette }) => palette.secondary[500]
        }
    },
    iconDisabled: {
        "& > path, & > g > path": {
            stroke: ({ palette }) => palette.greyscale[500]
        }
    },
    newTabIcon: {
        fill: "secondary.500",
        width: "18px",
        height: "18px"
    },
    customBlock: {
        container: {
            width: "100%"
        },
        wrapper: {
            mb: -0.5
        },
        body: {
            gap: 0
        }
    },
    validateProgressBar: {
        mt: 1,
        height: 8,
        borderRadius: 1,
        backgroundColor: "greyscale.200",
        " .MuiLinearProgress-bar": {
            backgroundColor: "secondary.500",
            borderRadius: 1
        }
    },
    revalidateIcon: {
        fill: "none",
        ml: 1.25,
        "& > g > path": {
            stroke: ({ palette }) => palette.secondary[500]
        }
    }
};
